// extracted by mini-css-extract-plugin
export default {"itemLocked":"SkillItem_itemLocked__g6YrW"};